import { createApi } from "@reduxjs/toolkit/dist/query/react";
import customBaseQuery from "../common/utils/customBaseQuery";

const contractManagementGepoApi = createApi({
	reducerPath: "contractManagementGepoApi",
	baseQuery: customBaseQuery({
		baseURL: import.meta.env.VITE_APP_API_PATH!,
	}),
	tagTypes: ["ChangeRequest", "Comments"],
	endpoints: () => ({}),
});

export default contractManagementGepoApi;
